import { useCurrentUser } from './useCurrentUser.context';

export function useDisplayName(fallbackUsername: string): string {
    const { displayName } = useCurrentUser();
    return displayName ?? fallbackUsername;
}
